import {
  Typography,
  Grid,
  IconButton,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { Suspense, lazy, useEffect, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import insta from "../../../../assests/Images/insta.png";
import youtube from "../../../../assests/Images/youtube.png";
import tele from "../../../../assests/Images/tele.png";
import book from "../../../../assests/Images/book.png";
import arrow from "../../../../assests/Images/2arrow.png";
import git from "../../../../assests/svg/github.svg";
import fb from "../../../../assests/svg/facebook-sidebar.svg";
import xSidebar from "../../../../assests/svg/x-sidebar.svg";
import In from "../../../../assests/Images/in.png";
import opensea from "../../../../assests/svg/opensea_.svg";

import xButton from "../../../../assests/svg/x-button.svg";
import telebtn from "../../../../assests/Images/Telegram.png";
import flashbtn from "../../../../assests/Images/flashbtn.png";
import { Languagemodel } from "../../../../Slice/translateSlice";
import { useSelector } from "react-redux";
import { getWhitepaperPdf } from "../../docs";

const Hero3D = lazy(() => import("../Hero3D"));

const heroEase = [0.22, 1, 0.36, 1];

const Banner = () => {
  const reduceMotion = useReducedMotion();
  // Defer Three.js until after first paint / idle so LCP isn't blocked.
  const [showHero3D, setShowHero3D] = useState(false);
  useEffect(() => {
    let cancelled = false;
    const enable = () => {
      if (!cancelled) setShowHero3D(true);
    };
    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      const id = window.requestIdleCallback(enable, { timeout: 1800 });
      return () => {
        cancelled = true;
        window.cancelIdleCallback?.(id);
      };
    }
    const t = window.setTimeout(enable, 900);
    return () => {
      cancelled = true;
      window.clearTimeout(t);
    };
  }, []);
  const rise = (delay = 0) =>
    reduceMotion
      ? {}
      : {
          initial: { opacity: 0, y: 28 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.8, delay, ease: heroEase },
        };
  const lang = useSelector(Languagemodel);
  const languageMode = useSelector((state) => state.translate.mode);
  const Navs = [
    {
      img: xSidebar,
      link: "https://x.com/Flash_Techno_Of",
      label: "X",
    },
    {
      img: tele,
      link: "https://t.me/flashtokenenglish",
      label: "Telegram",
    },
    {
      img: youtube,
      link: "https://www.youtube.com/channel/UCbNApPsnWrYixnri4hwUUyA",
      label: "YouTube",
    },
    {
      img: insta,
      link: "https://www.instagram.com/flash_techno_of/",
      label: "Instagram",
    },
    {
      img: fb,
      link: "https://www.facebook.com/flashtechnologiesoff/?show_switched_toast=0&show_invite_to_follow=0&show_switched_tooltip=0&show_podcast_settings=0&show_community_transition=0&show_community_review_changes=0&show_community_rollback=0&show_follower_visibility_disclosure=0",
      label: "Facebook",
    },
    {
      img: git,
      link: "https://github.com/Flash-Technologies",
      label: "GitHub",
    },
    {
      img: book,
      link: getWhitepaperPdf(languageMode),
      label: "Whitepaper",
    },
    {
      img: In,
      link: "https://www.linkedin.com/company/flash-technologies-off/",
      label: "LinkedIn",
    },
    {
      img: arrow,
      link: "https://linktr.ee/FlashTechnologies",
      label: "Linktree",
    },
    {
      img: opensea,
      link: "https://rarible.com/flashtechno/sale",
      label: "Rarible",
    },
    // {
    //   img: face,
    //   link: "https://www.pinksale.finance/launchpad/0x2E07c3B2bB52CA72149bdBCe6222D1826626F4f2?chain=BSC",
    // },
  ];
  return (
    <>
      <Grid
        container
        sx={{
          position: "relative",
          color: "white",
          height: { lg: "659px", xs: "640px" },
          paddingBottom: { lg: "0px", xs: "20px" },
          overflow: "hidden",
          "@media (min-width: 520px) and (max-width: 599.95px)": {
            height: "600px",
          },
        }}
      >
        {showHero3D ? (
          <Suspense fallback={null}>
            <Hero3D />
          </Suspense>
        ) : null}
        <Grid
          xs={12}
          item
          md={12}
          sx={{
            mt: { lg: "140px", xs: "0px" },
            display: "flex",
            justifyContent: "center",
            position: "relative",
            zIndex: 2,
          }}
        >
          <Grid
            item
            xs={12}
            md={11.5}
            sx={{
              display: "flex",
              flexDirection: { lg: "row", xs: "column" },
              justifyContent: "center",
            }}
          >
            <Grid item md={1.5}>
              <Box
                component={motion.div}
                {...(reduceMotion
                  ? {}
                  : {
                      initial: { opacity: 0, x: -24 },
                      animate: { opacity: 1, x: 0 },
                      transition: { duration: 0.9, delay: 0.55, ease: heroEase },
                    })}
                sx={{
                  width: "40px",
                  display: { lg: "flex", xs: "none" },
                  flexDirection: "column",
                  alignItems: "center",
                  borderRadius: "30.5px",
                  padding: "5px 0 0 0",
                  position: "relative",
                  zIndex: "999"
                }}
                className="social-vertical"
              >
                {Navs.map((i) => {
                  if (i.img == tele) {
                    return (
                      <Box key={i.label} sx={{ margin: "10px 0px" }}>
                        <a
                          id="telegramlink"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${languageMode == 'fr' ? 'https://t.me/flashtechnologiesfr' : 'https://t.me/flashtokenenglish'}`}
                          aria-label={i.label}
                        >
                          <img src={i.img} alt="" width="24" height="24" />
                        </a>
                      </Box>
                    )
                  }
                  else {
                    return (
                      <Box key={i.label} sx={{ margin: "10px 0px" }}>
                        {i.img == git || i.img == opensea ? <a href={i.link} target="_blank" rel="noopener noreferrer" aria-label={i.label}>
                          <img src={i.img} alt="" width="27" height="27" style={{ width: '27px' }} />
                        </a> :
                          <a href={i.link} target="_blank" rel="noopener noreferrer" aria-label={i.label}>
                            <img src={i.img} alt="" width="24" height="24" />
                          </a>
                        }
                      </Box>
                    );
                  }
                })}
              </Box>
            </Grid>

            <Grid item xs={12} md={6.8}>
              <Box
                sx={{
                  padding: { lg: "0px 0px", xs: "0px 30px" },
                  marginTop: { lg: "100px", xs: "90px" },
                  transform: { lg: "scale(0.8)", xs: "scale(none)" },
                }}
              >
                <Typography
                  component={motion.p}
                  {...rise(0.1)}
                  sx={{
                    textTransform: "uppercase",
                    fontFamily: "'Manrope' !important",
                    fontSize: { lg: "16px !important", xs: "12px !important" },
                    fontWeight: "600 !important",
                    // marginBottom: '10px',
                    lineHeight: { lg: "none", xs: "19.2px !important" },
                    color: "#FBBF04",
                  }}
                >
                  {lang["Flash Technologies L.L.C-FZ"]}

                </Typography>
                <Typography
                  component={motion.h1}
                  {...rise(0.22)}
                  sx={{
                    textTransform: "uppercase",
                    fontFamily: "'Manrope' !important",
                    fontSize: {
                      lg: "89.58px !important",
                      xs: "40px !important",
                    },
                    fontWeight: "800 !important",
                    lineHeight: { lg: "80px !important", xs: "52px !important" },
                    color: "#ffff",
                    "@media (min-width: 520px) and (max-width: 599.95px)": {
                      fontSize: "48px !important",
                      lineHeight: "58px !important",
                    },
                    // lineHeight: "1.2",
                  }}
                >
                  Flash
                </Typography>
                <Typography
                  component={motion.h1}
                  {...rise(0.34)}
                  sx={{
                    textTransform: "uppercase",
                    fontFamily: "'Manrope' !important",
                    fontSize: {
                      lg: "89.58px !important",
                      xs: "40px !important",
                    },
                    fontWeight: "800 !important",

                    color: { lg: "#FBBF04", sm: "#FBBF04", xs: "#FBBF04" },
                    lineHeight: { lg: "1", xs: "1.05" },
                    marginBottom: { lg: "30px", xs: "0px" },
                    "@media (min-width: 520px) and (max-width: 599.95px)": {
                      fontSize: "48px !important",
                    },
                  }}
                >
                  Technologies
                </Typography>

                <Grid
                  component={motion.div}
                  {...rise(0.48)}
                  container
                  columnSpacing={2}
                  rowSpacing={2}
                  // columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{
                    // mt: "-60px",
                    // transform: { lg: "scale(0.7)", xs: "scale(none)" },
                    display: { lg: "flex", xs: "none" },
                    // justifyContent:"space-between",
                    flexDirection: "row",
                    // padding: { lg: "0px 0px", xs: "0px 40px" },
                  }}
                >
                  <Grid item lg={4} md={4} xs={6}>
                    <a href="https://flash-dex.com/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', cursor: 'pointer' }}>

                      <IconButton
                        className="iconbutton hero-cta-pulse"
                        aria-label={lang["Buy Flash"] || "Buy Flash"}
                        sx={{
                          fontSize: { md: "20px", xs: "14px" },
                          padding: { lg: "15px 40px", xs: "8px 16px" },
                          height: { lg: "62px", xs: "37px" },
                          margin: "0px 5px",
                          fontWeight: 600,
                          lineHeight: "150%",
                          borderRadius: "69px",
                          color: "#0F0F0E",
                          fontStyle: "Manrope",
                          width: { lg: "100%", xs: "auto" },
                          backgroundColor: "#FBBF04",
                        }}
                      >
                        <img src={flashbtn} alt="" width="24" height="24" />
                        {lang["Buy Flash"]}
                      </IconButton>
                    </a>
                  </Grid>
                  <Grid item lg={3.3} md={4} xs={6}>
                    <a
                      target="_blank" rel="noopener noreferrer"
                      style={{ textDecoration: "none" }}
                      id="telegramlink4"
                      href={`${languageMode == 'fr' ? 'https://t.me/flashtechnologiesfr' : 'https://t.me/flashtokenenglish'}`}
                    >
                      <IconButton
                        className="iconbutton"
                        aria-label="Telegram"
                        sx={{
                          fontStyle: "Manrope",
                          fontSize: { md: "20px", xs: "14px" },
                          padding: { lg: "15px 20px", xs: "8px 16px" },
                          height: { lg: "62px", xs: "37px" },
                          margin: "0px 5px",
                          fontWeight: 600,
                          lineHeight: "150%",
                          borderRadius: "69px",
                          color: "#0F0F0E",
                          width: { lg: "100%", xs: "auto" },
                          backgroundColor: "#FBBF04",
                        }}
                      >
                        <img src={telebtn} alt="" width="25" height="25" style={{ marginRight: "5px", width: '25px' }} />
                        Telegram
                      </IconButton>
                    </a>
                  </Grid>

                  <Grid item lg={3.3} md={4} xs={6}>
                    <a
                      href="https://x.com/Flash_Techno_Of"
                      target="_blank" rel="noopener noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      <IconButton
                        className="iconbutton"
                        aria-label="X"
                        sx={{
                          fontStyle: "Manrope",
                          fontSize: { md: "20px", xs: "14px" },
                          padding: { lg: "15px 20px", xs: "8px 16px" },
                          height: { lg: "62px", xs: "37px" },
                          margin: "0px 5px",
                          fontWeight: 600,
                          lineHeight: "150%",
                          borderRadius: "69px",
                          color: "#0F0F0E",
                          width: { lg: "100%", xs: "auto" },
                          backgroundColor: "#FBBF04",
                        }}
                      >
                        <img src={xButton} alt="" width="25" height="25" style={{ margin: "0px 5px", width: '25px' }} />
                      </IconButton>
                    </a>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} md={3.7}>
              <Box
                sx={{
                  padding: { lg: "0px 0px", xs: "0px 30px" },
                  marginTop: { lg: "100px", xs: "10px" },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                  justifyContent: "flex-start",
                  transform: { lg: "scale(0.8)", xs: "scale(none)" },
                }}
              >
                <Typography
                  component={motion.p}
                  {...rise(0.4)}
                  sx={{
                    fontFamily: "'Manrope' !important",
                    fontSize: { lg: "26px !important", xs: "18px !important" },
                    fontWeight: "500 !important",
                    lineHeight: {
                      lg: "150% !important",
                      xs: "27px !important",
                    },
                    color: "#ffff",
                    marginBottom: { lg: "30px", xs: "20px" },
                    marginTop: { lg: "0px", xs: "-15px" },
                    maxWidth: "350px",
                    "@media (min-width: 520px) and (max-width: 599.95px)": {
                      maxWidth: "420px",
                    },
                  }}
                >
                  {lang["Flash Technologies creates a money transfer ecosystem."]}
                </Typography>
                <Typography
                  component={motion.p}
                  {...rise(0.52)}
                  sx={{
                    fontFamily: "'Manrope' !important",
                    fontSize: { lg: "14px !important", xs: "12px" },
                    fontWeight: "400 !important",
                    lineHeight: { lg: "165% !important", xs: "16px" },
                    color: { lg: "#85898F", sm: "#85898F", xs: "#FFFFFF" },
                    marginBottom: "40px",
                    maxWidth: "600px",
                    whiteSpace: 'pre-line'
                  }}
                >
                  {lang["Flash Transfer is the world's first platform that allows you to buy crypto with cash, transfer, or sell cryptocurrencies for cash through our network of merchants, with reasonable fees. Flash Wallet, our non-custodial wallet, has a smart contract that you can use to transfer your crypto in the event of death.  Find the best fees with Flash Dex, our aggregator swap & bridge!"]}
                </Typography>
                <Box
                  component={motion.div}
                  {...(reduceMotion
                    ? {}
                    : {
                        initial: { scaleX: 0, opacity: 0 },
                        animate: { scaleX: 1, opacity: 1 },
                        transition: { duration: 0.7, delay: 0.75, ease: heroEase },
                      })}
                  sx={{
                    display: { lg: "flex", xs: "none" },
                    transformOrigin: "left center",
                  }}
                >
                  <div style={{ width: '100px', height: '1px', backgroundColor: "#FBBF04" }}>
                  </div>
                  
                </Box>
              </Box>
            </Grid>
            <Grid
              container
              columnSpacing={2}
              rowSpacing={2}
              sx={{
                padding: { lg: "0px 0px", xs: "0px 24px" },
                display: { lg: "none", xs: "flex" },
                flexDirection: "row",
                "@media (min-width: 520px) and (max-width: 599.95px)": {
                  padding: "0px 36px",
                },
              }}
            >
              <Grid
                item
                md={4}
                xs={6}
                sx={{
                  marginLeft: 0,
                }}
                className="resp-buttons"
              >
                <a href="https://flash-dex.com/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', cursor: 'pointer' }}>

                  <IconButton
                    className="iconbutton hero-cta-pulse"
                    aria-label={lang["Buy Flash"] || "Buy Flash"}
                    sx={{
                      fontSize: { md: "20px", xs: "14px" },
                      padding: { lg: "15px 40px", xs: "8px 10px" },
                      height: { lg: "62px", xs: "37px" },
                      margin: "0px 5px",
                      fontWeight: 600,
                      width: "95%",
                      lineHeight: "150%",
                      borderRadius: "69px",
                      color: "#0F0F0E",

                      // width: { lg: "100%", xs: "auto" },
                      backgroundColor: "#FBBF04",
                    }}
                  >
                    <img
                      src={flashbtn}
                      alt=""
                      width="24"
                      height="21"
                      style={{ width: "24px", height: "21.33px" }}
                    />
                    {lang["Buy Flash"]}
                  </IconButton>
                </a>
              </Grid>
              <Grid
                item
                lg={3.3}
                md={4}
                xs={6}
                sx={{}}
                className="resp-buttons"
              >
                <a
                  id="telegramlink3"
                  target="_blank" rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                  href={`${languageMode == 'fr' ? 'https://t.me/flashtechnologiesfr' : 'https://t.me/flashtokenenglish'}`}
                >
                  <IconButton
                    className="iconbutton"
                    aria-label="Telegram"
                    sx={{
                      height: { lg: "62px", xs: "37px" },
                      fontSize: { md: "20px", xs: "14px" },
                      fontWeight: 600,
                      padding: { lg: "15px 40px", xs: "8px 10px" },
                      margin: "0px 5px",
                      lineHeight: "150%",
                      borderRadius: "69px",
                      color: "#0F0F0E",
                      border: "1px solid #FBBF04",
                      width: { lg: "auto", xs: "93%" },
                      backgroundColor: "#FBBF04",
                    }}
                  >
                    <img
                      src={telebtn}
                      alt=""
                      width="18"
                      height="15"
                      style={{
                        width: "18px",
                        height: "14.73px",
                        marginRight: "5px",
                      }}
                    />
                    Telegram
                  </IconButton>
                </a>
              </Grid>

              <Grid
                item
                lg={3.3}
                md={4}
                xs={12}
                sx={{
                  marginLeft: 0,
                }}
                className="resp-buttons"
              >
                <a
                  href="https://x.com/Flash_Techno_Of"
                  target="_blank" rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <IconButton
                    className="iconbutton"
                    aria-label="X"
                    sx={{
                      fontSize: { md: "20px", xs: "14px" },
                      padding: { lg: "15px 40px", xs: "8px 10px" },
                      height: { lg: "62px", xs: "37px" },

                      fontWeight: 600,
                      margin: "0px 5px",

                      lineHeight: "150%",
                      borderRadius: "69px",
                      minWidth: "120px",
                      color: "#0F0F0E",
                      border: "1px solid #FBBF04",
                      width: { lg: "auto", xs: "auto" },
                      backgroundColor: "#FBBF04",
                    }}
                  >
                    <img
                      src={xButton}
                      alt=""
                      width="20"
                      height="20"
                      style={{
                        width: "20px",
                        height: "20px",
                        margin: "0px 5px",
                      }}
                    />
                  </IconButton>
                </a>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Banner;
